import {ValueObject} from '@s-ui/domain'

export class ImageResourcesValueObject extends ValueObject {
  #url

  constructor({url}) {
    super()
    this.#url = url
  }

  static createFromImageUrl({url}) {
    return new ImageResourcesValueObject({url})
  }

  static createFromResource({resource}) {
    return new ImageResourcesValueObject({url: resource.url})
  }

  get url() {
    return this.#url
  }

  get value() {
    return this.url
  }
}
